"use strict";

import Vue from 'vue';
import axios from "axios";
import router from '@/router'
import store from '@/store'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.params = {
      _: Date.now(),
      ...config.params
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

let flag = false

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    let s = (error && error.response) ? error.response.status : 500,
      url = error.config.url, method = error.config.method.toLowerCase(), reqData = error.config.data

    switch (s) {
      case 401:
        /* 401状态 发起重复登录 */
        if(!flag) {
          flag = true
          // console.log('静默登录前')
          let _t = localStorage.getItem('__token_d')
          if(_t){
            /* localStorage 中有 token，使用 token 登录 */
            return Promise.resolve(
              _axios.get('/m/login', {
                params: {
                  _t: 1,
                  token: _t,
                  _l: encodeURIComponent(url)
                }
              }).then(resp => {
                // console.log('更新flag：静默登录成功')
                flag = false
                // console.log('请求静默登录结束')
                let data = resp.data
                if(data && data.status == 'ok'){
                  /* 静默登录成功后刷新本页 */
                  // console.log('静默登录成功')
                  localStorage.setItem('__token_d', data.message.token)
                  store.commit('changeUserId', data.message.id)
                  if(window.TongAnBridge && window.TongAnBridge.setJSessionId && data.jsessionid){
                    window.TongAnBridge.setJSessionId(data.jsessionid)
                  }
                  // router.go(0)
                  // console.log('重新请求数据')
                  if(method == 'get'){
                    return Promise.resolve(
                      _axios.get(url).then(resp => {
                        // console.log('请求成功')
                        return resp
                      })
                    )
                  } else {
                    return Promise.resolve(
                      _axios.post(url, reqData).then(resp => {
                        // console.log('请求成功')
                        return resp
                      })
                    )
                  }
                } else {
                  store.commit('bindError', data.message || '系统错误')
                  router.push('/login')
                }
              }).catch(err => {
                store.commit('bindError', '静默登录失败')
                flag = false
                console.log(err)
                router.push('/login')
              })
            )
          } else {
            store.commit('bindError', '没有token')
            flag = false
            router.push('/login')
          }
        } else {
          // console.log('等待其他401')
          return new Promise((resolve => {
            setTimeout(() => {
              if(method == 'get'){
                resolve (
                  _axios.get(url).then(resp => {
                    // console.log('其他请求401后请求成功')
                    return resp
                  })
                )
              } else {
                resolve (
                  _axios.post(url, reqData).then(resp => {
                    // console.log('其他请求401后请求成功')
                    return resp
                  })
                )
              }
            }, 2000)
          }))
        }
        break
      case 400:
        break
      case 404:
        break
      case 500:
        break
      default:
        store('bindError', `服务器其他错误 error code: ${s} -> url: ${url}`)
        router.push('/login')
    }

    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
